<!--
 * @Author: cmchiu
 * @Date: 2023-05-05 11:04:24
 * @LastEditTime: 2023-05-19 13:39:02
 * @LastEditors: cmchiu
 * @Description: 
 * @FilePath: \IACMP\IACMP_Client\src\components\Pagination\pagination.vue
 * 
-->
<template>
    <div class="pagination">
        <el-pagination
            class="number-pagination d-flex justify-content-center"
            layout="prev, pager, next"
            :current-page.sync="currentCurrPage"
            :page-size="pageSize"
            :total="currentTotal"
            :pager-count="pagerCount"
            @current-change="pageChange"
        >
        </el-pagination>
    </div>
</template>

<script>
export default {
    name: 'pagination',

    props: {
        // 每頁顯示資料列數
        pageSize: {
            type: Number,
            default: 6,
        },

        // 頁碼按鈕數, 當總頁數超過該值時會折疊
        pagerCount: {
            type: Number,
            default: 4,
        },

        // 總資料列數
        total: {
            type: Number,
            default: 6,
            required: true,
        },

        // 當前頁數
        currPage: {
            type: Number,
            default: 0,
            required: true,
        },
    },

    data() {
        return {}
    },

    created() {},

    computed: {
        /* currentModel: {
            get() {
                return this.model
            },
            set(val) {
                this.$emit('update:model', val)
            },
        }, */

        currentTotal: {
            get() {
                return this.total
            },
            set(val) {
                this.$emit('update:total', val)
            },
        },

        currentCurrPage: {
            get() {
                return this.currPage
            },
            set(val) {
                this.$emit('update:currPage', val)
            },
        },
    },

    methods: {
        pageChange(val) {
            this.$emit('page-change', val)
        },
    },
}
</script>

<style lang="scss" scoped>
.pagination:deep .el-pagination {
    .btn-prev .el-icon,
    .btn-next .el-icon {
        font-size: 25px;
        padding-top: 8px;
    }

    .btn-prev {
        margin-right: 15px;
    }

    .el-pager {
        li {
            font-size: 18px;
            border-radius: 50%;
            width: 40px;
            height: 40px;
            padding-top: 4px;
            margin-right: 15px;
        }

        .active {
            color: #fff;
            background-color: #021dac;
        }
    }
}
</style>
